// import React, { Component } from "react";
// import {
//     Accordion,
//     AccordionDetails,
//     AccordionSummary,
//     Checkbox,
//     FormControlLabel,
//     Divider,
//     Typography,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// class DynamicAccordion extends Component {
//     constructor(props) {
//         super(props);
//         // console.log("jjjj",props)
//         this.state = {
//             selectedActions: this.props.initial_permissions || {},
//         };
//     }

//     handleCheckboxChange = (module, action) => {
//         // alert(module)
//         this.setState((prevState) => {
//             const currentActions = prevState.selectedActions[module] || [];

//             const isSelected = currentActions.includes(action);

//             const updatedModuleActions = isSelected
//                 ? currentActions.filter((a) => a !== action)
//                 : [...currentActions, action];

//             const updatedSelectedActions = {
//                 ...prevState.selectedActions,
//                 [module]: updatedModuleActions,
//             };

//             // Remove module if no actions are selected
//             if (updatedModuleActions.length === 0) {
//                 delete updatedSelectedActions[module];
//             }

//             // 🔔 Emit to parent
//             this.props.onChange?.(updatedSelectedActions);

//             return { selectedActions: updatedSelectedActions };
//         });
//     };


//     render() {
//         const { modulesData = [] } = this.props;

//         if (!modulesData.length) {
//             return (
//                 <Typography variant="h6" style={{ textAlign: "center", marginTop: "20px" }}>
//                     No Data Available
//                 </Typography>
//             );
//         }

//         return (
//             <div style={{ width: "100%" }}>
//                 {modulesData.map((moduleItem) => {
//                     // ✅ Count checked actions for this module
//                     //   const checkedCount = Object.values(this.state.selectedActions[moduleItem.module] || {}).filter(Boolean).length;
//                     const checkedCount = (this.state.selectedActions[moduleItem.module] || []).length;

//                     return (
//                         <Accordion key={moduleItem.module} sx={{ marginBottom: "12px", textTransform: 'capitalize' }}>
//                             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                 <Typography variant="subtitle1">
//                                     {moduleItem.module}
//                                     {/* ✅ Show checked count */}
//                                     {checkedCount > 0 && (
//                                         <Typography component="span" style={{ marginLeft: "8px", color: "#1976d2" }}>
//                                             ({checkedCount} selected)
//                                         </Typography>
//                                     )}
//                                 </Typography>
//                             </AccordionSummary>
//                             <AccordionDetails style={{ display: "flex", flexDirection: "column"}}>
//                                 {moduleItem.actions.map((action) => (

//                                     <div style={{ display: "flex", alignItems: "baseline", justifyContent: "start", gap: "5px" }}>
//                                         <input
//                                             type="checkbox"
//                                             style={{ width: "14px" }}
//                                             id={action}
//                                             checked={this.state.selectedActions[moduleItem.module]?.includes(action)}
//                                             onChange={() => this.handleCheckboxChange(moduleItem.module, action)}
//                                         />
//                                         <label htmlFor={action} style={{ position: "unset", fontSize: "14px", color:'black' }}>{action}</label>
//                                     </div>
//                                 ))}
//                             </AccordionDetails>
//                             <Divider />
//                         </Accordion>
//                     );
//                 })}
//             </div>
//         );
//     }
// }

// export default DynamicAccordion;


import React, { Component } from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Checkbox,
    FormControlLabel,
    Divider,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

class DynamicAccordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedActions: this.props.initial_permissions || {},
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.initial_permissions !== this.props.initial_permissions) {
            this.setState({
                selectedActions: this.props.initial_permissions || {},
            });
        }
    }

    handleCheckboxChange = (module, action) => {
        this.setState((prevState) => {
            const currentActions = prevState.selectedActions[module] || [];
            const isSelected = currentActions.includes(action);

            const updatedModuleActions = isSelected
                ? currentActions.filter((a) => a !== action)
                : [...currentActions, action];

            const updatedSelectedActions = {
                ...prevState.selectedActions,
                [module]: updatedModuleActions,
            };

            // Remove module if no actions are selected
            if (updatedModuleActions.length === 0) {
                delete updatedSelectedActions[module];
            }

            this.props.onChange?.(updatedSelectedActions);

            return { selectedActions: updatedSelectedActions };
        });
    };

    render() {
        const { modulesData = [] } = this.props;
        const { selectedActions } = this.state;

        if (!modulesData.length) {
            return (
                <Typography variant="h6" style={{ textAlign: "center", marginTop: "20px" }}>
                    No Data Available
                </Typography>
            );
        }

        return (
            <div style={{ width: "100%" }}>
                {modulesData.map((moduleItem) => {
                    const checkedCount = (selectedActions[moduleItem.module] || []).length;

                    return (
                        <Accordion key={moduleItem.module} sx={{ marginBottom: "12px", textTransform: 'capitalize' }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="subtitle1">
                                    {moduleItem.module}
                                    {checkedCount > 0 && (
                                        <Typography component="span" style={{ marginLeft: "8px", color: "#1976d2" }}>
                                            ({checkedCount} selected)
                                        </Typography>
                                    )}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails style={{ display: "flex", flexDirection: "column" }}>
                                {moduleItem.actions.map((action) => (
                                    <div
                                        key={action}
                                        style={{
                                            display: "flex",
                                            alignItems: "baseline",
                                            justifyContent: "start",
                                            gap: "5px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            style={{ width: "14px" }}
                                            id={`${moduleItem.module}-${action}`}
                                            checked={selectedActions[moduleItem.module]?.includes(action)}
                                            onChange={() => this.handleCheckboxChange(moduleItem.module, action)}
                                        />
                                        <label
                                            htmlFor={`${moduleItem.module}-${action}`}
                                            style={{ position: "unset", fontSize: "14px", color: 'black' }}
                                        >
                                            {action}
                                        </label>
                                    </div>
                                ))}
                            </AccordionDetails>
                            <Divider />
                        </Accordion>
                    );
                })}
            </div>
        );
    }
}

export default DynamicAccordion;

